module.exports = __webpack_public_path__ + "static/media/cornami_logo_h_600px.4c30993a.jpg";